import { render, staticRenderFns } from "./other_doc.vue?vue&type=template&id=b13a3cb6&scoped=true"
import script from "./other_doc.vue?vue&type=script&lang=js"
export * from "./other_doc.vue?vue&type=script&lang=js"
import style0 from "./doc.css?vue&type=style&index=0&id=b13a3cb6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13a3cb6",
  null
  
)

export default component.exports